import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Swiper as OriginSwiper, SwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";

import { useScrollLockContext } from "../../contexts/scrollLockContext";

type Props = {
  imageList: (File | string)[];
  isOpen: boolean;
  onClose: (e: React.MouseEvent) => void;
};

export default function PinchZoomImage({ isOpen, imageList, onClose }: Props) {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [isZoomed, setIsZoomed] = useState<boolean>(false);

  const handleChange = (swiper: any) => {
    setActiveIndex(swiper.activeIndex);
  };

  const [, { lockScroll, unlockScroll }] = useScrollLockContext();

  useEffect(() => {
    if (isOpen) {
      const scrollId = lockScroll?.({});

      return () => {
        unlockScroll?.({ activeElements: [scrollId] });
      };
    }

    setIsZoomed(false);
  }, [isOpen]);

  const handleZoomChange = (scale: number) => {
    setIsZoomed(scale > 1.5); // 1: 기본 배율
  };

  return (
    <>
      {isOpen && (
        <div className="w-full fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
          <div className="relative">
            {(imageList?.length ?? 0) > 1 && (
              <div className="absolute text-white top-[50px] left-1/2 -translate-x-1/2 z-10 p-2.5 leading-[19px]">
                {activeIndex + 1 ?? 1} / {imageList.length ?? 0}
              </div>
            )}

            <OriginSwiper
              onSlideChange={handleChange}
              className="w-screen h-screen"
              allowSlidePrev={!isZoomed}
              allowSlideNext={!isZoomed}
            >
              {imageList.map((image, index) => (
                <SwiperSlide key={index}>
                  <TransformWrapper
                    onTransformed={(e) => handleZoomChange(e.state.scale)}
                  >
                    <TransformComponent>
                      <img
                        src={
                          typeof image === "string"
                            ? image
                            : URL.createObjectURL(image)
                        }
                        alt={`${index}번째 이미지`}
                        className="min-h-screen object-contain min-w-full"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </SwiperSlide>
              ))}
            </OriginSwiper>

            <button
              className="absolute top-5 right-5 cursor-pointer z-10"
              onClick={(e) => onClose?.(e)}
            >
              <PinchZoomCloseButton />
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export const PinchZoomCloseButton = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="white"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="white"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
